"use client"

import React, {useEffect, useState} from 'react';
import { loadCmpMappingClientSide } from '../helper/api'
import { CmpMappingResponse } from '../helper/interfaces';

type ConsentContext = { 
  fixedVendorIds: string[];
  getProviderId: (identifier: string) => string;
}

const defaultContext: ConsentContext = {
  fixedVendorIds: [],
  getProviderId: (identifier: string) => ""
};

export const ConsentContext = React.createContext<ConsentContext>(defaultContext);

type ConsentContextProviderProps = {
  children: React.ReactNode;
};

export const ConsentContextProvider: React.FC<ConsentContextProviderProps> = ({ children }) => {
  const [fixedVendorIds, setFixedVendorIds] = useState(["s904", "s7", "c3524", "s14", "488", "s34", "s77", "s30"]);
  const [cmpMapping, setCmpMapping] = useState<Record<string, string>>({});

  const getProviderId = (identifier: string) => {
    const entry = cmpMapping[identifier];
    if(entry) {
      return entry;
    }
    else {
      return "";
    }
  }

  const loadMapping = async() => {
    const mapping: CmpMappingResponse | null = await loadCmpMappingClientSide()
    if(mapping && mapping.setCmpMappingWithFrameSize?.length > 0) {
      setFixedVendorIds(mapping.setCmpMappingWithFrameSize)
    }
    if(mapping && mapping.cmpVendorIdMapping) {
      setCmpMapping(mapping.cmpVendorIdMapping)
    }
  }
  useEffect(() => {
    loadMapping()
  }, [])

  return (
    <ConsentContext.Provider value={{ fixedVendorIds, getProviderId }}>
      {children}
    </ConsentContext.Provider>
  );
};